import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TransitionTest from "../pages/transition-test/page";
import ProjectsIndex from "../pages/projects/page";
import ProjectDetail from "../pages/projects/detail/page";
import ServicesIndex from "../pages/services/page";
import ServiceDetail from "../pages/services/detail/page";
import ProcessPage from "../pages/process/page";
import StudioPage from "../pages/studio/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/projects", element: <ProjectsIndex /> },
  { path: "/projects/:slug", element: <ProjectDetail /> },
  { path: "/services", element: <ServicesIndex /> },
  { path: "/services/:slug", element: <ServiceDetail /> },
  { path: "/process", element: <ProcessPage /> },
  { path: "/studio", element: <StudioPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/transition-test", element: <TransitionTest /> },
  { path: "*", element: <NotFound /> },
];

export default routes;